import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "",
      titleType: "home",
    },
  },
  {
    path: "/user",
    name: "User",
    component: () => import("../views/user/index.vue"),
    meta: {
      title: "",
      titleType: "noTitle",
      tabbar: true,
      keepAlive: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login/login.vue"),
    meta: {
      title: "登录",
      titleType: "noTitle",
    },
  },
  {
    path: "/registration",
    name: "Registration",
    component: () => import("../views/login/registration.vue"),
    meta: {
      title: "注册",
      titleType: "noTitle",
    },
  },
  {
    path: "/user/agreement",
    name: "Agreement",
    component: () => import("../views/user/agreement.vue"),
    meta: {
      title: "用户协议",
    },
  },
  {
    path: "/user/privacyPolicy",
    name: "PrivacyPolicy",
    component: () => import("../views/user/privacyPolicy.vue"),
    meta: {
      title: "隐私协议",
    },
  },
  {
    path: "/goods/classifyList",
    name: "ClassifyList",
    component: () => import("../views//goods/classifyList.vue"),
    meta: {
      title: "全部分类",
      titleType: "noBack",
      tabbar: true,
    },
  },
  {
    path: "/goods/cart",
    name: "Cart",
    component: () => import("../views//goods/cart.vue"),
    meta: {
      title: "采购车",
      titleType: "noTitle",
      tabbar: true,
    },
  },
  {
    path: "/goods/list",
    name: "List",
    component: () => import("../views//goods/list.vue"),
    meta: {
      title: "列表",
      titleType: "noTitle",
      keepAlive: true,
    },
  },
  {
    path: "/goods/shop",
    name: "Shop",
    component: () => import("../views//goods/shop.vue"),
    meta: {
      title: "工厂详情",
      titleType: "noTitle",
      keepAlive: true,
    },
  },
  {
    path: "/goods/details",
    name: "Details",
    component: () => import("../views//goods/details.vue"),
    meta: {
      title: "商品详情",
    },
  },
  {
    path: "/order/buy",
    name: "Buy",
    component: () => import("../views//order/buy.vue"),
    meta: {
      title: "订单结算",
    },
  },
  {
    path: "/order/details",
    name: "OrderDetails",
    component: () => import("../views//order/details.vue"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/user/addressList",
    name: "AddressList",
    component: () => import("../views//user/addressList.vue"),
    meta: {
      title: "地址管理",
    },
  },
  {
    path: "/user/selectAddress",
    name: "SelectAddress",
    component: () => import("../views//user/selectAddress.vue"),
    meta: {
      title: "选择收货地址",
    },
  },
  {
    path: "/order/pay",
    name: "Pay",
    component: () => import("../views/order/pay.vue"),
    meta: {
      title: "待支付",
    },
  },
  {
    path: "/order/payResult",
    name: "PayResult",
    component: () => import("../views/order/payResult.vue"),
    meta: {
      title: "支付结果",
    },
  },
  // -------------------------------创客中心预览页面------------------------------
  {
    path: "/maker",
    name: "Maker",
    component: () => import("../views/maker/index.vue"),
    meta: {
      title: "创客首页",
      titleType: "noTitle",
    },
  },
  {
    path: "/maker/customJewelry",
    name: "CustomJewelry",
    component: () => import("../views/maker/customJewelry.vue"),
    meta: {
      title: "Custom Jewelry",
    },
  },
  {
    path: "/maker/earrings",
    name: "Earrings",
    component: () => import("../views/maker/earrings.vue"),
    meta: {
      title: "Earrings",
      titleType: "noTitle",
    },
  },
  {
    path: "/maker/details",
    name: "MakerDetails",
    component: () => import("../views/maker/details.vue"),
    meta: {
      title: "Product details",
    },
  },
  // -------------------------------创客中心预览页面 end------------------------------
  {
    path: "/advert/billingDetailAdvert",
    name: "BillingDetailAdvert",
    component: () => import("../views/advert/billingDetailAdvert.vue"),
    meta: {
      title: "收款转账明细",
    },
  },
  {
    path: "/advert/advert1",
    name: "Advert1",
    component: () => import("../views/advert/advert1.vue"),
    meta: {
      title: "克隆外贸网站",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
